// eslint-disable-next-line no-restricted-imports
import type {
  MathJsStatic,
  MathNode as MathJsNode,
  Matrix as MathJsMatrix,
} from 'mathjs'
// eslint-disable-next-line no-restricted-imports
import {
  absDependencies,
  create,
  evaluateDependencies,
  indexDependencies,
  lusolveDependencies,
  matrixDependencies,
  maxDependencies,
  minDependencies,
  multiplyDependencies,
  parseDependencies,
  piDependencies,
  qrDependencies,
  rangeDependencies,
  roundDependencies,
  sqrtDependencies,
  subsetDependencies,
  transposeDependencies,
  unitDependencies,
} from 'mathjs'

const dependencies = {
  absDependencies,
  evaluateDependencies,
  indexDependencies,
  lusolveDependencies,
  matrixDependencies,
  maxDependencies,
  minDependencies,
  multiplyDependencies,
  parseDependencies,
  piDependencies,
  qrDependencies,
  rangeDependencies,
  roundDependencies,
  sqrtDependencies,
  subsetDependencies,
  transposeDependencies,
  unitDependencies,
}

const math = create(dependencies)

export type ForecastMath = Pick<
  MathJsStatic,
  | 'abs'
  | 'evaluate'
  | 'index'
  | 'lusolve'
  | 'matrix'
  | 'max'
  | 'min'
  | 'multiply'
  | 'parse'
  | 'pi'
  | 'qr'
  | 'range'
  | 'round'
  | 'sqrt'
  | 'subset'
  | 'transpose'
  | 'unit'
  | 'isFunctionNode'
  | 'isOperatorNode'
  | 'isParenthesisNode'
  | 'isSymbolNode'
>

export const forecastMath = math as ForecastMath

export type MathNode = MathJsNode
export type Matrix = MathJsMatrix
